export default "__VITE_ASSET__5f5c0c98__"